document.addEventListener("DOMContentLoaded", () => {
  const swiperElement = document.querySelector('.loginBlogSlider');
  if (!swiperElement) return;

  const swiper = new Swiper(".loginBlogSlider", {
    slidesPerView: 1.15,
    spaceBetween: 16,
    loop: true,
    loopedSlides: 8, // Non-stop continuous loop ke liye duplicate slides create karta hai
    speed: 3500, // Movement ki speed (Jitna barhayenge utna slow aur smooth chalega)
    autoplay: {
      delay: 0, // Zero delay zaroori hai uninterrupted continuous marquee ke liye
      disableOnInteraction: false,
      pauseOnMouseEnter: true // Hover karne par ruk jayega
    },
    grabCursor: true,
    simulateTouch: true,
    allowTouchMove: true,
    breakpoints: {
      480: { slidesPerView: 1.25, spaceBetween: 16 },
      640: { slidesPerView: 2, spaceBetween: 16 },
      768: { slidesPerView: 3, spaceBetween: 22 },
      1024: { slidesPerView: 4, spaceBetween: 22 }
    }
  });

  let animationFrameId = null;
  let isHovered = false;
  let isDragging = false;
  const scrollSpeed = 1; // Animation speed (Aapki original exact speed)

  // Continuous Seamless Motion Loop Engine
  // function animateMarquee() {
  //   if (!isHovered && !isDragging) {
  //     let currentTranslate = swiper.getTranslate();
  //     let nextTranslate = currentTranslate - scrollSpeed;

  //     // Single slide width + gap for smooth reset limit
  //     const maxTranslate = -swiper.snapGrid[swiper.snapGrid.length - 1];

  //     // Smooth Infinite Loop Logic (Resetting position cleanly)
  //     if (nextTranslate <= maxTranslate) {
  //       nextTranslate = 1;
  //     }

  //     swiper.setTransition(0);
  //     swiper.setTranslate(nextTranslate);
  //     swiper.updateProgress();
  //   }
  //   animationFrameId = requestAnimationFrame(animateMarquee);
  // }

  // Engine Start
  animationFrameId = requestAnimationFrame(animateMarquee);

  // --- Mouse Hover Handling ---
  swiperElement.addEventListener('mouseenter', () => {
    isHovered = true;
  });

  swiperElement.addEventListener('mouseleave', () => {
    isHovered = false;
  });

  // --- Drag / Touch Handling ---
  swiper.on('touchStart', () => {
    isDragging = true;
  });

  swiper.on('touchEnd', () => {
    isDragging = false;
  });
});